<template>
  <div class="profile-container">
    <!-- 页面标题和返回按钮 -->
    <div class="profile-header">
      <el-button
        type="text"
        icon="el-icon-back"
        @click="goBack"
        class="back-btn"
      >
        返回主页
      </el-button>
    </div>

    <!-- 主要内容区域 -->
    <div class="profile-content">
      <!-- 左侧个人信息卡片 -->
      <div class="top-section">
        <el-card class="info-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">个人信息</span>
          </div>

          <!-- 头像区域 -->
          <div class="avatar-section">
            <div class="avatar-wrapper">
              <el-avatar
                :size="60"
                :src="avatar"
                class="user-avatar"
                shape="circle"
              ></el-avatar>

              <!-- 头像上传按钮 -->
              <div class="avatar-upload">
                <el-upload
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="handleFileChange"
                  action=""
                >
                  <el-button
                    type="primary"
                    icon="el-icon-camera"
                    size="small"
                    round
                  >
                    更换头像
                  </el-button>
                </el-upload>
                <p class="upload-tip">支持 JPG、PNG 格式，大小不超过 1MB</p>
              </div>
            </div>
          </div>

          <!-- 用户基本信息 -->
          <div class="user-info">
            <div class="info-item">
              <span class="info-label">用户名</span>
              <div class="info-value">
                <el-input
                  v-model="userInfo.username"
                  disabled
                  class="disabled-input"
                >
                  <template slot="append">
                    <el-tooltip content="用户名不可更改" placement="top">
                      <i class="el-icon-lock"></i>
                    </el-tooltip>
                  </template>
                </el-input>
              </div>
            </div>

            <div class="info-item">
              <span class="info-label">邮箱</span>
              <div class="info-value">
                <el-input v-model="email" disabled></el-input>
              </div>
            </div>

            <div class="info-item">
              <span class="info-label">注册时间</span>
              <div class="info-value">
                <el-input :value="formatDate(createTime)" disabled></el-input>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 右侧积分和操作功能 -->
      <div class="bottom-section">
        <el-card class="points-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">我的积分</span>
            <el-tooltip content="积分可用于兑换特权和服务" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>

          <div class="points-content">
            <div class="points-info">
              <!-- 积分展示 -->
              <div class="points-display">
                <div class="points-number">
                  <span class="points-value">{{ points || 0 }}</span>
                  <span class="points-unit">分</span>
                </div>
                <div class="points-level">
                  <el-tag :type="getPointsLevel(points).type">
                    {{ getPointsLevel(points).name }}
                  </el-tag>
                </div>
              </div>

              <!-- 今日签到 -->
              <div class="daily-checkin" v-if="!checkedInToday">
                <el-button
                  type="primary"
                  @click="handleCheckin"
                  :loading="checkingIn"
                  round
                >
                  <i class="el-icon-date"></i>
                  今日签到+1分
                </el-button>
                <p class="checkin-tip">每日首次登录可获得积分</p>
              </div>
              <div class="daily-checkin" v-else>
                <el-button type="success" disabled round class="checkin-btn">
                  <i class="el-icon-success"></i>
                  今日已签到
                </el-button>
                <p class="checkin-tip">明天再来签到哦~</p>
              </div>

              <div class="points-record">
                <el-button type="primary" @click="handleRecord" round>
                  <i class="el-icon-date"></i>
                  查看积分记录
                </el-button>
              </div>
            </div>

            <el-divider></el-divider>

            <!-- 邀请好友模块 -->
            <div class="invite-section">
              <h4>邀请好友获得奖励</h4>
              <div class="invite-content">
                <div class="invite-link">
                  <p class="invite-label">邀请链接</p>
                  <el-input v-model="inviteLink" readonly class="invite-input">
                    <template slot="append">
                      <el-button @click="copyInviteLink" type="primary">
                        复制链接
                      </el-button>
                    </template>
                  </el-input>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 积分记录对话框 -->
    <el-dialog
      title="积分记录"
      :visible.sync="recordDialogVisible"
      width="600px"
      center
      :close-on-click-modal="false"
    >
      <el-table
        :data="pointsHistory"
        stripe
        style="width: 100%"
        max-height="400"
      >
        <el-table-column prop="time" label="日期" width="160"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column
          prop="points"
          label="积分变动"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span
              :class="scope.row.points > 0 ? 'points-plus' : 'points-minus'"
            >
              {{ scope.row.points > 0 ? "+" : "" }}{{ scope.row.points }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { INDEX_PATH } from "../utilis/enum";

export default {
  name: "Profile",

  data() {
    return {
      defaultAvatar:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

      // 用户信息
      userInfo: {
        username: "",
        nickname: "",
        email: "",
        avatar: "",
        createTime: "",
      },

      // 积分历史
      pointsHistory: [],

      // 签到相关
      checkedInToday: false,
      checkingIn: false,

      // 邀请相关
      inviteDialogVisible: false,

      // 积分记录对话框显示状态
      recordDialogVisible: false,
    };
  },

  computed: {
    ...mapGetters("user", [
      "userName",
      "userAvatar",
      "points",
      "invitation",
      "email",
      "createTime",
    ]),

    // 添加state映射
    ...mapState("user", {
      vuexPoints: (state) => state.points,
      vuexInvitation: (state) => state.invitation,
    }),

    avatar() {
      return this.userAvatar ? this.userAvatar : this.defaultAvatar; // 修复引用错误
    },

    // 邀请链接作为计算属性
    inviteLink() {
      const baseUrl = window.location.origin;
      const inviteCode = this.invitation || this.vuexInvitation || "";
      return `${baseUrl}/register?invitation=${inviteCode}`;
    },

    // 当前积分
    currentPoints() {
      return this.points || this.vuexPoints || 0;
    },

    pointsLevels() {
      return [
        { min: 0, max: 100, name: "初级用户", type: "info" },
        { min: 101, max: 500, name: "中级用户", type: "success" },
        { min: 501, max: 2000, name: "高级用户", type: "warning" },
        { min: 2001, max: Infinity, name: "VIP用户", type: "danger" },
      ];
    },
  },

  created() {
    this.loadUserInfo();
    this.loadPointsHistory();
    this.checkTodayCheckin();
  },

  methods: {
    ...mapActions("user", ["updateUserInfo", "checkin", "updateAvatar"]),

    // 返回主页
    goBack() {
      this.$router.push(INDEX_PATH);
    },

    // 加载用户信息
    async loadUserInfo() {
      try {
        // 使用Vuex中的数据来初始化
        this.userInfo = {
          username: this.userName || "user123",
          nickname: "庐鸣助手",
          email: "user@example.com",
          avatar: this.userAvatar || this.defaultAvatar,
          createTime: "2023-01-15 10:30:00",
        };
      } catch (error) {
        console.error("加载用户信息失败:", error);
        this.$message.error("加载用户信息失败");
      }
    },

    // 加载积分记录
    async loadPointsHistory() {
      try {
        // 模拟数据（实际应调用API）
        this.pointsHistory = [
          {
            description: "每日签到奖励",
            points: 5,
            time: this.formatTime(new Date()),
          },
          {
            description: "完成任务「数据清洗」",
            points: 50,
            time: "2023-10-26 14:30",
          },
          { description: "邀请好友注册", points: 50, time: "2023-10-25 10:15" },
          { description: "数据分享", points: 20, time: "2023-10-24 16:45" },
          {
            description: "完成任务「数据分析」",
            points: 80,
            time: "2023-10-23 09:20",
          },
        ];
      } catch (error) {
        console.error("加载积分记录失败:", error);
      }
    },

    // 检查今日是否已签到
    async checkTodayCheckin() {
      try {
        const today = new Date().toDateString();
        const lastCheckin = localStorage.getItem("lastCheckin");
        this.checkedInToday = lastCheckin === today;
      } catch (error) {
        console.error("检查签到状态失败:", error);
      }
    },

    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      return date.toLocaleDateString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    // 格式化时间
    formatTime(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");
      const hour = d.getHours().toString().padStart(2, "0");
      const minute = d.getMinutes().toString().padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}`;
    },

    // 获取积分等级
    getPointsLevel(points) {
      const actualPoints = points || this.currentPoints || 0;
      const level = this.pointsLevels.find(
        (level) => actualPoints >= level.min && actualPoints <= level.max
      );
      return level || this.pointsLevels[0];
    },

    beforeAvatarUpload(file) {
      console.log(file);
      const isImage = /^image\/(jpeg|png|jpg|gif)$/.test(file.type);
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!isImage) {
        this.$message.error("只能上传 JPG/PNG/GIF 格式的图片!");
        return false;
      }

      if (!isLt1M) {
        this.$message.error("图片大小不能超过 1MB!");
        return false;
      }

      return true;
    },

    async handleFileChange(file) {
      const uploadFile = file.raw;
      const uploadAvatar = this.beforeAvatarUpload(uploadFile);
      if (!uploadAvatar) {
        return;
      }
      this.updateAvatar(uploadFile);
    },

    // 处理签到
    async handleCheckin() {
      this.checkingIn = true;

      try {
        const result = await this.checkin();

        if (result && result.code === 200) {
          this.checkedInToday = true;
          const now = new Date();
          this.pointsHistory.unshift({
            description: "每日签到奖励",
            points: 5,
            time: this.formatTime(now),
          });

          localStorage.setItem("lastCheckin", now.toDateString());

          this.$message.success("签到成功！积分+1");
        } else {
          this.$message.error(result.message || "签到失败");
        }
      } catch (error) {
        console.error("签到失败:", error);
        this.$message.error("签到失败");
      } finally {
        this.checkingIn = false;
      }
    },

    // 查看积分记录 -> 打开对话框
    handleRecord() {
      this.recordDialogVisible = true;
    },

    // 复制邀请链接
    copyInviteLink() {
      if (!navigator.clipboard) {
        // 降级方案
        const textarea = document.createElement("textarea");
        textarea.value = this.inviteLink;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      } else {
        // 现代浏览器
        navigator.clipboard.writeText(this.inviteLink);
      }

      this.$message.success("邀请链接已复制到剪贴板");
    },
  },

  // 添加watch监听Vuex数据变化
  watch: {
    userName: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.userInfo) {
          this.userInfo.username = newVal;
        }
      },
    },
    userAvatar: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.userInfo) {
          this.userInfo.avatar = newVal;
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.profile-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background: #f5f7fa;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;

  .profile-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .back-btn {
      margin-right: 20px;
      color: #1890ff;
      font-size: 16px;

      i {
        margin-right: 5px;
      }

      &:hover {
        color: #40a9ff;
      }
    }

    .header-title {
      flex: 1;

      h1 {
        font-size: 28px;
        color: #333;
        margin: 0 0 5px 0;
      }

      p {
        color: #666;
        font-size: 14px;
        margin: 0;
      }
    }
  }

  .profile-content {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .top-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;

      .info-card {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;

        ::v-deep .el-card__body {
          display: flex;
          flex-direction: row !important;
          flex: 1;
        }

        .card-header {
          .card-title {
            font-size: 18px;
            font-weight: bold;
            color: #333;
          }
        }

        .avatar-section {
          display: flex;
          justify-content: center;
          margin-bottom: 30px;

          .avatar-wrapper {
            text-align: center;

            .user-avatar {
              border: 4px solid #f0f0f0;
              margin-bottom: 15px;
            }

            .avatar-upload {
              .avatar-uploader {
                display: inline-block;
              }

              .upload-tip {
                margin-top: 10px;
                color: #999;
                font-size: 12px;
              }
            }
          }
        }

        .user-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-left: 60px;

          .info-item {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            flex: 1;

            .info-label {
              width: 80px;
              color: #666;
              font-size: 14px;
            }

            .info-value {
              flex: 1;
            }
          }
        }
      }
    }

    .bottom-section {
      flex: 1;
      display: flex;
      flex-direction: column;

      .points-card {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;

        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .card-title {
            font-size: 18px;
            font-weight: bold;
            color: #333;
          }
        }

        .points-content {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;

          .points-info {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-around;
            gap: 20px;

            .points-display {
              text-align: center;
              padding: 20px 0;
              flex-shrink: 0;

              .points-number {
                margin-bottom: 15px;

                .points-value {
                  font-size: 28px;
                  font-weight: bold;
                  color: #1890ff;
                }

                .points-unit {
                  font-size: 18px;
                  color: #666;
                  margin-left: 5px;
                }
              }
            }

            .daily-checkin {
              text-align: center;
              margin: 20px 0;
              flex-shrink: 0;

              .checkin-tip {
                margin-top: 10px;
                color: #999;
                font-size: 12px;
              }
            }
          }

          .invite-section {
            margin-bottom: 20px;
            flex-shrink: 0;

            h4 {
              color: #333;
              font-size: 16px;
            }

            .invite-content {
              background: #f8f9fa;
              padding: 15px;
              border-radius: 8px;

              .invite-code {
                margin-bottom: 20px;

                .invite-label {
                  color: #666;
                  margin-bottom: 5px;
                }

                .code-display {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  background: white;
                  padding: 10px 15px;
                  border-radius: 4px;
                  border: 1px solid #e4e7ed;

                  .code-text {
                    font-size: 18px;
                    font-weight: bold;
                    letter-spacing: 2px;
                    color: #1890ff;
                  }

                  .copy-btn {
                    color: #1890ff;
                  }
                }

                .invite-tip {
                  margin-top: 5px;
                  color: #999;
                  font-size: 12px;
                }
              }

              .invite-link {
                .invite-label {
                  color: #666;
                  margin-bottom: 5px;
                }

                .invite-input {
                  margin-bottom: 10px;
                }

                .share-buttons {
                  display: flex;
                  justify-content: space-between;

                  .share-btn {
                    flex: 1;
                    margin: 0 5px;
                  }
                }
              }
            }
          }

          .points-history {
            flex: 1;
            display: flex;
            flex-direction: column;
            min-height: 0;
            overflow: hidden;

            h4 {
              margin-bottom: 15px;
              color: #333;
              font-size: 16px;
              flex-shrink: 0;
            }

            .history-table {
              flex: 1;
              overflow-y: auto;
            }

            .points-plus {
              color: #67c23a;
              font-weight: bold;
            }

            .points-minus {
              color: #f56c6c;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>
